module.exports = __webpack_public_path__ + "static/key-deadlight-af121339ecd7d268ca9847211d46089d.webp";